import styled from "@emotion/styled";

export const CadastrarCupomForm = styled.form`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    gap: 0.5rem;
`

